<template>
  <div>
    <v-img class="tw-rounded-md" :src="lobby.image" min-height="160" height="100%">
      <template v-slot:placeholder>
        <v-sheet>
          <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
        </v-sheet>
      </template>
    </v-img>
    <div class="tw-absolute tw-top-1 tw-right-1">
      <div v-if="lobby.isOpen" class="tw-text-green-300 tw-text-xs">Open</div>
      <div v-else class="tw-text-red-400 tw-text-xs">Close</div>
    </div>

    <v-hover v-slot="{ hover }" class="tw-absolute tw-inset-0 tw-z-20">
      <v-expand-transition>
        <div :class="`lobby-item-hover  ${hover && ' tw-bg-gradient-to-t tw-from-[#111] tw-to-transparent'}`">
          <div class="tw-text-left">
            <div class="tw-text-sm">{{lobby.name}}</div>
            <div class="tw-text-xs tw-text-[#D6B447]">{{ lobby.dealerName && lobby.dealerName != "undefined" ? lobby.dealerName :"No Name" }}</div>
          </div>
        </div>
      </v-expand-transition>
    </v-hover>
  </div>
</template>

<script>
export default {
  props: ["lobby"],
};
</script>

<style>
</style>